<template>
  <div class="orderManagement">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">{{ $t.orderManagement.orderNo }}：{{ item.OrderNo }}</div>
        <div class="list-item">
          {{ $t.orderManagement.expressNo }}：{{ item.ExpressNo }}
        </div>
        <div class="list-item">
          {{ $t.orderManagement.wbNumber }}：{{ item.WB_Number }}
        </div>
        <div class="list-item">
          {{ $t.orderManagement.serviceProvider }}：<span
            v-if="item.LogisticsChannel == 0"
            >{{ $t.orderManagement.none }}</span
          ><span v-if="item.LogisticsChannel == 1">Naqel</span>
          <span v-if="item.LogisticsChannel == 2">iMile</span>
        </div>
        <div class="list-item">
          {{ $t.orderManagement.cargoCategory }}：{{ item.TransportationService }}
        </div>
        <div class="list-item">
          {{ $t.orderManagement.shipperName }}：{{ item.ShipperContact }} /
          {{ item.ShipperPhoneNumber }}
        </div>
        <div class="list-item">
          {{ $t.orderManagement.consigneeName }}：{{ item.ConsigneeContact }} /
          {{ item.ConsigneePhoneNumber }}
        </div>
        <div class="list-item">
          {{ $t.orderManagement.declareValue }}：{{ item.DeclaredValue }}
        </div>
        <div class="list-item">
          {{ $t.orderManagement.declareValueCurrency }}：{{ item.DeclaredValueCurrency }}
        </div>
        <div class="list-item">
          {{ $t.orderManagement.weight }}：{{ item.TotalWeight }}
        </div>
        <div class="list-item">
          {{ $t.orderManagement.orderDate }}：{{ item.CreateTime }}
        </div>
        <div class="buttons">
          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoPrint(item.WB_Number)"
            >{{ $t.onlineOrder.faceSheet }}</van-button
          >

          <van-button
            class="primary-btn"
            size="small"
            type="primary"
            @click="gotoDetail(item.CLOId)"
            >{{ $t.meta.viewDetail }}</van-button
          >
        </div>
      </div>
    </van-list>
    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.orderManagement.serviceProvider }}</div>
        <van-radio-group v-model="logisticsChannel" direction="horizontal">
          <van-radio :name="0">{{ $t.orderManagement.none }}</van-radio>
          <van-radio :name="1">Naqel</van-radio>
          <van-radio :name="2">iMile</van-radio>
        </van-radio-group>

        <van-field
          clickable
          readonly
          :value="countryName"
          :label="$t.meta.country"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showOrderManagementCountry')"
        />

        <van-field
          clickable
          readonly
          :value="fpdIdStr"
          :label="$t.orderManagement.cargoCategory"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showOrderManagementService')"
        />

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <option-list
      event="showOrderManagementCountry"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showOrderManagementService"
      :options="freightList"
      @onSelect="onSelectService"
    ></option-list>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <div class="tool-bar">
      <van-button type="info" block @click="gotoDetail(null)">{{
        $t.orderManagement.addButton
      }}</van-button>
    </div>
  </div>
</template>

<script>
import OptionList from "@components/optionList/OptionList.vue";
import {
  List,
  Tab,
  Tabs,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Popup,
  Picker,
  Image,
  Radio,
  RadioGroup,
  DatetimePicker,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Tab)
  .use(Tabs)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Popup)
  .use(Picker)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(DatetimePicker);

export default {
  name: "orderManagement",
  components: {
    OptionList,
  },
  data() {
    return {
      tableData: [],
      page: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      showFilter: false,
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.orderManagement.search1,
          value: 1,
        },
        {
          text: this.$t.orderManagement.search2,
          value: 2,
        },
      ],
      logisticsChannel: null,
      countryName: "",
      countryId: null,
      fpdIdStr: "",
      fpdId: null,
      countryList: [],
      freightList: [],
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
    };
  },
  created() {
    this.getCountryList();
  },
  methods: {
    onSelectCountry(item) {
      this.countryName = item.text;
      this.countryId = item.value;
      this.fpdIdStr = "";
      this.fpdId = null;
      this.loadFreightPriceInfo();
    },
    onSelectService(item) {
      this.fpdIdStr = item.text;
      this.fpdId = item.value;
    },
    getCountryList() {
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName + "," + item.CountryName_en,
                value: item.CountryId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    loadFreightPriceInfo() {
      this.$commonMethod.showLoading();
      var param = {
        FPId: this.countryId,
      };
      return new Promise((resolve) => {
        this.$api.onlineOrderManagement
          .loadFreightPriceInfo(param)
          .then((res) => {
            var result = [];
            var data = res.data;
            if (data && data.DetailList) {
              data.DetailList.forEach((item) => {
                let data = {
                  text: item.CargoCategory,
                  value: item.FPDId,
                };
                result.push(data);
              });
            }
            this.freightList = result;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    gotoDetail(id) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "orderManagementDetail",
        name: "orderManagementDetail",
        query: [
          {
            name: "CLOId",
            value: id,
          },
        ],
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (
        this.logisticsChannel ||
        this.countryId ||
        this.fpdId ||
        (this.beginTime && this.endTime)
      ) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.logisticsChannel = null;
      this.countryName = "";
      this.countryId = null;
      this.fpdIdStr = "";
      this.fpdId = null;
      this.beginTime = "";
      this.endTime = "";
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        searchNumber: this.searchType == 1 ? this.searchText : "",
        searchContacts: this.searchType == 2 ? this.searchText : "",
        LogisticsChannel: this.logisticsChannel,
        countryId: this.countryId,
        fpdId: this.fpdId,
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      this.$api.orderManagement
        .getCustomerLogisticsOrderListByPage(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    gotoPrint(id) {
      var param = {
        WB_Number: id,
        Type: 2,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createBarCodePdf",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";

.orderManagement {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;

    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;

      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;

        .van-search__content {
          padding: 0px;
          margin-right: 10px;

          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }

        .custom-date {
          padding: 10px;

          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }

          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }

          .van-button {
            vertical-align: middle;
          }
        }
      }

      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;

        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }

  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);

      .list-item {
        margin-bottom: 10px;
      }

      .list-item:last-child {
        margin-bottom: 0px;
      }

      .buttons {
        text-align: right;

        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }

        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }

        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }

        .danger-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;

          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }

  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }

  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }

  .van-radio-group {
    margin-bottom: 20px;
  }

  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;

    ::v-deep .van-radio__label {
      color: #646566;
    }
  }

  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;

    .van-cell:after {
      border: none;
    }

    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }

    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;

      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }

      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;

        .van-button__text {
          font-size: 14px !important;
        }
      }

      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;

        .van-button__text {
          font-size: 14px !important;
        }
      }

      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }

  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;

    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }

    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }

  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);

    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
